var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonHeader',{attrs:{"page":'Corbeille'}}),_c('b-container',{staticStyle:{"padding-top":"20px"},attrs:{"fluid":""}},[_c('ProductsTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }